import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import api from "../../api";

const HappeningsAtChettinad = () => {
  const [happenings, setHappenings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await api.get(
          `${process.env.REACT_APP_API_URL}/api/happenings`
        );
        if (response.data.status) {
          setHappenings(response.data.data);
        } else {
          setError(response.data.message);
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  if (loading) return <></>;
  if (error) return <></>;
  if (happenings.length === 0) return <></>;

  // ✅ Dynamic slider settings
  const settings = {
    dots: false,
    speed: 500,
    autoplay: happenings.length > 1, // autoplay only if multiple
    autoplaySpeed: 5000,
    slidesToShow: happenings.length === 1 ? 1 : 2,
    slidesToScroll: 1,
    infinite: happenings.length > 1, // infinite only if multiple
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: happenings.length === 1 ? 1 : 2,
        },
      },
      {
        breakpoint: 768,
        settings: { slidesToShow: 1 },
      },
    ],
  };

  return (
    <section className="research-area">
      <div className="auto-container">
        <div className="sec-title text-center">
          <h2>Happenings At Chettinad</h2>
        </div>
        <div className="container">
          <div className="row">
            <div className="col-xl-12">
              <div className="theme_carousel highschool-carousel">
                <Slider {...settings}>
                  {happenings.map((item) => (
                    <div key={item.id} className="single-research-box">
                      <div className="img-holder">
                        <img
                          src={
                            process.env.REACT_APP_API_URL +
                            "/public/" +
                            item.image_url
                          }
                          alt={item.title}
                        />
                      </div>
                      <div className="overlay-content">
                        <div className="inner-title">
                          <h3>
                            {item.link ? (
                              <a href={item.link}>{item.title}</a>
                            ) : (
                              item.title
                            )}
                          </h3>
                        </div>
                        <div className="text">
                          <p>{item.description}</p>
                        </div>
                      </div>
                    </div>
                  ))}
                </Slider>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HappeningsAtChettinad;